import {useNavigate} from 'react-router-dom'
import {KTIcon} from '../../../../../_metronic/helpers'
import useAuthorization from '../../../../../hooks/useAuthorization'

const ListToolbar = () => {
  const navigate = useNavigate()
  const handleToCreate = () => navigate('/admin/users/create')
  const isAuthorizedToCreate = useAuthorization('admin.users')
  if (!isAuthorizedToCreate) return <></>

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <button type='button' className='btn btn-light-danger' onClick={handleToCreate}>
        <KTIcon iconName='plus' className='fs-2' />
        Adicionar Usuário
      </button>
    </div>
  )
}

export {ListToolbar}
